import axios from 'axios';
import * as React from 'react';
import Styles from './Hero.module.css';
import { useState, useEffect } from 'react';
import Popup from './Popup';
import { baseCarPrices, calculatePrice } from './carPrices';

const Hero = ({ selectedCar }) => {

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [buttonPopup, setButtonPopup] = useState(false);

  const [secname, setSecame] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [pick, setPick] = useState('');
  const [drop, setDrop] = useState('');
  const [uptime, setUptime] = useState('');
  const [update, setUpdate] = useState('');
  const [dowdate, setDowdate] = useState('');
  const [dowtime, setDowtime] = useState('');
  const [age, setAge] = useState('');
  const [car, setCar] = useState(selectedCar || '');

  const [dailyPrice, setDailyPrice] = useState(0);
  const [rentalDays, setRentalDays] = useState(0);
  const [locationFee, setLocationFee] = useState(0);
  const [locationReason, setLocationReason] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    if (selectedCar) setCar(selectedCar);
  }, [selectedCar]);

  useEffect(() => {
    if (car && baseCarPrices[car]) {
      setDailyPrice(baseCarPrices[car]);
    }
  }, [car]);

  // 🕒 დროების გენერაცია
  const generateTimes = (location) => {
    const times = [];
    const start = location?.includes('Tbilisi Office') ? 9 : 0;
    const end = location?.includes('Tbilisi Office') ? 18 : 23;

    for (let h = start; h <= end; h++) {
      const hour = h.toString().padStart(2, '0');
      times.push(`${hour}:00`);
      if (h !== end) times.push(`${hour}:30`);
    }

    return times;
  };

  // 📍 ლოკაციის ფასი
  const calculateLocationFee = (pick, drop) => {
    if (!pick || !drop) return { fee: 0, reason: '' };

    const isTbilisi = (l) => l.includes('Tbilisi');
    const isBatumi = (l) => l.includes('Batumi');
    const isKutaisi = (l) => l.includes('Qutaisi');

    if (isTbilisi(pick) && isTbilisi(drop)) {
      return { fee: 0, reason: '' };
    }

    if (
      (isTbilisi(pick) && (isBatumi(drop) || isKutaisi(drop))) ||
      (isTbilisi(drop) && (isBatumi(pick) || isKutaisi(pick)))
    ) {
      return {
        fee: 200,
        reason: 'Different city drop-off (vehicle relocation)'
      };
    }

    if (
      (isBatumi(pick) && isKutaisi(drop)) ||
      (isKutaisi(pick) && isBatumi(drop))
    ) {
      return {
        fee: 150,
        reason: 'Regional transfer between cities'
      };
    }

    return { fee: 0, reason: '' };
  };

  // 💰 ფასი
  useEffect(() => {
    if (update && dowdate && car) {
      const start = new Date(update);
      const end = new Date(dowdate);
      const diffDays = Math.ceil((end - start) / (1000 * 3600 * 24));

      if (diffDays > 0) {
        const pricePerDay = calculatePrice(car, diffDays);
        const { fee, reason } = calculateLocationFee(pick, drop);

        setRentalDays(diffDays);
        setDailyPrice(pricePerDay);
        setLocationFee(fee);
        setLocationReason(reason);
        setTotalPrice(diffDays * pricePerDay + fee);
      } else {
        setRentalDays(0);
        setTotalPrice(0);
      }
    }
  }, [update, dowdate, car, pick, drop]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      name && secname && age && pick && drop &&
      uptime && update && dowdate && dowtime &&
      email && car && totalPrice
    ) {
      setFormSubmitted(true);
    } else {
      setFormSubmitted(false);
      return;
    }

    await axios.post("https://api.emailjs.com/api/v1.0/email/send", {
      service_id: 'service_ad4hc8p',
      template_id: 'template_u3i3o0o',
      user_id: '3wSy1f_-2IVu91d0F',
      template_params: {
        from_pick: pick,
        from_drop: drop,
        from_update: update,
        from_dowdate: dowdate,
        from_uptime: uptime,
        from_dowtime: dowtime,
        from_age: age,
        from_name: name,
        from_secname: secname,
        from_email: email,
        from_car: car,
        from_price: totalPrice,
        from_locationFee: locationFee,
      }
    });
  };

  return (
    <form onSubmit={handleSubmit} className={Styles.forma}>
      <div className={Styles.grid}>

        <input value={name} onChange={e => setName(e.target.value)} placeholder="First Name *" required />
        <input value={secname} onChange={e => setSecame(e.target.value)} placeholder="Last Name *" required />

        <select value={age} onChange={e => setAge(e.target.value)} required>
          <option value="">Age *</option>
          <option>25-30</option>
          <option>30-35</option>
          <option>35-40</option>
          <option>40+</option>
        </select>

        <select value={pick} onChange={e => { setPick(e.target.value); setUptime(''); }} required>
          <option value="">Pick-up location *</option>
          <option>Tbilisi Office</option>
          <option>Tbilisi Airport</option>
          <option>Qutaisi Office</option>
          <option>Batumi Office</option>
        </select>

        <input type="date" value={update} onChange={e => setUpdate(e.target.value)} required />

        <select value={uptime} onChange={e => setUptime(e.target.value)} required>
          <option value="">Pick-up time *</option>
          {generateTimes(pick).map(t => <option key={t}>{t}</option>)}
        </select>

        <select value={drop} onChange={e => { setDrop(e.target.value); setDowtime(''); }} required>
          <option value="">Drop-off location *</option>
          <option>Tbilisi Office</option>
          <option>Tbilisi Airport</option>
          <option>Qutaisi Office</option>
          <option>Batumi Office</option>
        </select>

        <input type="date" value={dowdate} onChange={e => setDowdate(e.target.value)} required />

        <select value={dowtime} onChange={e => setDowtime(e.target.value)} required>
          <option value="">Drop-off time *</option>
          {generateTimes(drop).map(t => <option key={t}>{t}</option>)}
        </select>

        {selectedCar ? (
          <div className={Styles.selectedCar}>🚗 {selectedCar}</div>
        ) : (
          <select value={car} onChange={e => setCar(e.target.value)} required>
            <option value="">Select car *</option>
            {Object.keys(baseCarPrices).map(c => <option key={c}>{c}</option>)}
          </select>
        )}

        <input type="email" placeholder="Email *" value={email} onChange={e => setEmail(e.target.value)} required />
      </div>

      <div className={Styles.priceBox}>
        <span>€{dailyPrice} / day</span>
        {rentalDays > 0 && <span>{rentalDays} days</span>}
        {locationFee > 0 && <span>+€{locationFee}</span>}
        {totalPrice > 0 && <strong>Total: €{totalPrice}</strong>}
      </div>

      {/* 📍 დამატებითი ინფორმაცია */}
      {locationFee > 0 && (
        <div className={Styles.extraInfo}>
          📍 {locationReason} (+€{locationFee})
        </div>
      )}

      {/* 🎉 ფასდაკლება */}
      {rentalDays >= 14 && (
        <div className={Styles.discount}>
          🎉 2+ Week Discount Applied!
        </div>
      )}

      {rentalDays >= 7 && rentalDays < 14 && (
        <div className={Styles.discount}>
          🎉 Week+ Discount Applied!
        </div>
      )}

      <button type="submit" onClick={() => setButtonPopup(true)} className={Styles.btn}>
        Book Now
      </button>

      <Popup trigger={buttonPopup} setTrigger={setButtonPopup}>
        {formSubmitted ? (
          <>
            <h3>✅ Booking successful</h3>
            <p>Email confirmation within 24h</p>
          </>
        ) : (
          <h3>⚠️ Fill all fields</h3>
        )}
      </Popup>

    </form>
  );
};

export default Hero;